import React, { useState } from "react";
import "./style.css";
import { EyeIcon, EyeOffIcon } from "../../icons";
import { cn } from "../../../utils/classnames";

const InputForm = ({
    type = "text",
    prefixIcon = null,
    suffixIcon = null,
    placeholder = "",
    suffixClass = "mb-3",
    mbLabel = "mb-1",
    suffixClassLabel,
    onChange,
    value,
    name = "",
    label = null,
    infoLabel = null,
    disable = false,
    onBlur,
    isInvalid = false,
    invalidMessage = "",
    innerRef,
    id,
    readOnly = false,
    index = 0,
    suffixOnClick = null,
    key = ""
}) => {
    const [showPassword, setShowPassword] = useState(false);
    const isPasswordField = type === "password";
    const actualInputType = isPasswordField ? (showPassword ? "text" : "password") : type;

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <>
            <div className={suffixClass} key={key}>
                {
                    label && (
                        <label className={`${mbLabel || ''} ${suffixClassLabel || ''}`}>
                            {label} &nbsp;
                            {infoLabel && (
                                <p className="info-label">{infoLabel}</p>
                            )}
                        </label>
                    )
                }
                {/* The focus outline is drawn on this rounded outer box (gold, or a soft
                    red ring when invalid). The inner row deliberately does not use the
                    global .input-container class: its focus border has square corners. */}
                <div
                    className={cn(
                        "w-100 rounded tw:transition-[border-color,box-shadow] tw:duration-200",
                        !disable && "border",
                        isInvalid
                            ? "invalid tw:focus-within:shadow-[0_0_0_3px_rgba(229,72,77,0.15)]"
                            : "tw:focus-within:!border-[#DBBE78] tw:focus-within:shadow-[0_0_0_3px_rgba(219,190,120,0.18)]"
                    )}
                >
                    <div className="d-flex align-items-center gap-2">
                        {prefixIcon && (
                            <span className="ms-3">
                                {prefixIcon}
                            </span>
                        )}
                        <input
                            className={`input-field w-100 rounded border-0 py-2 no-calendar ${prefixIcon != null ? '' : 'px-3'} ${disable && 'bg-grey-light'}`}
                            type={actualInputType}
                            id={id}
                            placeholder={placeholder}
                            onChange={(e) => onChange(e)}
                            name={name}
                            value={value}
                            disabled={disable}
                            onBlur={onBlur}
                            ref={innerRef}
                            readOnly={readOnly}
                            style={isPasswordField ? { paddingRight: '45px' } : {}}
                        />
                        {isPasswordField ? (
                            <div
                                onClick={togglePasswordVisibility}
                                className="me-3 pointer"
                                style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding: '4px'
                                }}
                            >
                                {showPassword ? (
                                    <EyeIcon />
                                ) : (
                                    <EyeOffIcon />
                                )}
                            </div>
                        ) : (
                            suffixIcon && (
                                <span
                                    // Only clickable when a handler is given (status icons have none).
                                    onClick={suffixOnClick ? () => suffixOnClick(index) : undefined}
                                    className={`me-3 ${suffixOnClick ? "pointer" : ""}`}
                                >
                                    {suffixIcon}
                                </span>
                            )
                        )}
                    </div>
                </div>
                {
                    (isInvalid && invalidMessage !== "") &&
                    (
                        <p className="text-danger">
                            {invalidMessage}
                        </p>
                    )
                }
            </div>
        </>
    );
};

export default InputForm;
